import { Box } from '@wix/design-system'
import React, { FC, ReactNode } from 'react'

import s from './HeadlessBackground.scss'

interface HeadlessBackgroundProps {
  dataHook?: string
  children?: ReactNode
}

export const HeadlessBackground: FC<HeadlessBackgroundProps> = ({ dataHook, children }) => {
  return (
    <Box className={s.page} dataHook={dataHook}>
      {children}
    </Box>
  )
}
